/**
 * Init CF7/Tartaucitron tracking
 */
const Tracking = () => {
    setupContactTracking();

    
    function setupContactTracking()
    {
        var wpcf7Elm = document.querySelector( '.wpcf7' );
        wpcf7Elm.addEventListener( 'wpcf7submit', function( event )
        {
            var gtagOK = isTrackingServiceGranted('gtag');
            var gtag2OK = isTrackingServiceGranted('multiplegtag', 'gtag');

            if(gtagOK || gtag2OK)
              gtag('event', 'Validation Formulaire');
        }, false );
    }

    /**
     * Check if a tracking service exists and is allowed throught Tarte Au Citron
     * 
     * @param {string} serviceName The service name (see window.tarteaucitron.services keys in you console to find the right name)
     * @param {string} funcName The tracking called function. Leave it empty to use the same as ServiceName
     * 
     * @returns {boolean}
     */
    function isTrackingServiceGranted(serviceName, funcName)
    {
        if(funcName === undefined || funcName === null)
          funcName = serviceName;
        var hasTarteAuCitron = (window.tarteaucitron !== null && window.tarteaucitron !== undefined);
        var funcExists = (typeof window[funcName] === 'function');
        var tacHasService = (hasTarteAuCitron) ? (window.tarteaucitron.state[serviceName] !== undefined) : false;
        if(!funcExists)
          return false;
        return (
          (!hasTarteAuCitron) ||
          (tacHasService && window.tarteaucitron.state[serviceName] === true)
        );
    }
}
export default Tracking;

